
import React from 'react';

const SkeletonCard = () => {
  return (
    <div className="flex flex-col animate-pulse">
      {/* Thumbnail Skeleton */}
      <div className="relative rounded-lg overflow-hidden mb-3 bg-gray-200 h-44 w-full"></div>
      
      {/* User Info Skeleton */}
      <div className="flex items-center mb-2">
        <div className="w-6 h-6 rounded-full mr-2 bg-gray-200"></div>
        <div className="h-4 bg-gray-200 rounded w-24"></div>
      </div>
      
      {/* Title Skeleton */}
      <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
      <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
      
      {/* Rating Skeleton */}
      <div className="flex items-center mb-1">
        <div className="w-4 h-4 bg-gray-200 rounded mr-1"></div>
        <div className="h-3 bg-gray-200 rounded w-8"></div>
      </div>
      
      {/* Price Skeleton */}
      <div className="mt-auto">
        <div className="h-4 bg-gray-200 rounded w-16"></div>
      </div>
    </div>
  );
};

export default SkeletonCard;
